import { Breadcrumbs, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CardPrimary from "../../components/Card/Card.Primary";

import { HeadingPrimary } from "../../components/Styles/Heading";
import config, { Theme } from "../../config/aws-exports";
import { session } from "../../redux/Session/Session";
import { Link, useNavigate } from "react-router-dom";
import { sessionAll } from "../../redux/viewAll/viewAll";
import moment from "moment";

import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import CardSecondary from "../../components/Card/Card.Secondary";
import CardSecondaryTopics from "../../components/Card/Card.Secondary.Topics";
import emptysearch from "../../assets/Nothing here yet.gif";

export default function ViewAll() {
  const { type, header, data,allCourses } = useSelector(
    (state) => state.sessionViewAll.value
  );
  console.log("allcourses",{allCourses });
  const dispatch = useDispatch();
      const navigate = useNavigate();
  const breadcrumbs = [
    <Link to="/dashboard">Dashboard</Link>,
    <Typography key="3" color={Theme.color.text}>
      View all
    </Typography>,
  ];
  return (
    <>
      <Stack spacing={3} margin={{ xs: "1rem", sm: "3rem" }}>
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
          sx={{ color: Theme.color.black }}
        >
          {breadcrumbs}
        </Breadcrumbs>
        <HeadingPrimary>{header}</HeadingPrimary>
        <Grid spacing={2} container>
          {console.log("data")}
          {data?.map((item, idx) => {
            return (
              <Grid item xs={12} sm={6} md={4} lg={type === "session" ? 3 : 4}>
                {type === "session" ? (
                  <CardPrimary
                    key={idx + "UKCsdf"}
                    auth={true}
                    title={item?.sn}
                    img={
                      item.sid &&
                      `https://${
                        config.aws_cloudfront_url
                      }/${config.aws_org_id.toLowerCase()}-resources/images/session-images/${
                        item.sid
                      }.png`
                    }
                    addToBookMarkList={() => {}}
                    addToFavorite={item.EI}
                    sessionType={item.stype}
                    sessionDate={
                      moment(item?.date_list?.[0]?.date).format(
                        "DD MMM YYYY"
                      ) === "invalid date"
                        ? "Yet to be Scheduled"
                        : moment(item?.date_list?.[0]?.date).format(
                            "DD MMM YYYY"
                          )
                    }
                    handleLocation={() => {
                      navigate(`/session?sid=${item.sid}`);
                      dispatch(session(item));
                    }}
                  />
                ) : type === "myTopics" ? (

                  
                  <CardSecondaryTopics
                    key={idx}
                    img={
                      item?.id &&
                      `https://${
                        config.aws_cloudfront_url
                      }/${config.aws_org_id.toLowerCase()}-resources/images/category-images/${
                        item?.ct_img
                      }`
                    }
                    title={item?.name}
                      handleLocation={() => {
                      const filteredTopics = allCourses?.filter(
                        (course) => course.cgry_id === item?.id
                      );

                      dispatch(
                        sessionAll({
                          type: "course", 
                          header: item?.name,
                          data: filteredTopics,
                          allCourses: allCourses,
                        })
                      );
                    }}
                  />
                ) : (
                  <CardSecondary
                    key={idx}
                    img={
                      item?.tid &&
                      `https://${
                        config.aws_cloudfront_url
                      }/${config.aws_org_id.toLowerCase()}-resources/images/topic-images/${
                        item?.tid
                      }.png`
                    }
                    title={item?.ttitle}
                    sessionDate={
                      item.startdate &&
                      moment(parseInt(item.startdate)).format("DD MMM YYYY")
                    }
                    handleLocation={() => {
                      navigate(`/course?id=${item?.tid}`);
                      dispatch(session({ ...item }));
                    }}
                    nonug={item?.noofnuggets}
                  />
                )}
              </Grid>
            );
          })}
        </Grid>
        {data?.length === 0 ? (
          <div
            style={{
              height: "60vh",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <img src={emptysearch} alt="emptysearch" />
          </div>
        ) : null}
      </Stack>
    </>
  );
}
